export const METRIC_IDS = {
  GROSS_SALES: 'grossSales',
  NET_SALES: 'netSales',
  ORDER_COUNT: 'orderCount',
  AVERAGE_ORDER_VALUE: 'averageOrderValue',
  TOTAL_REVENUE: 'totalRevenue',
  ITEMS_SOLD: 'itemsSold',
  TIPS: 'tips',
  AVERAGE_TIP_RATE: 'averageTipRate',
} as const;

export const METRIC_COLORS = {
  GROSS_SALES: '#10b981',
  NET_SALES: '#3b82f6',
  ORDER_COUNT: '#8b5cf6',
  AVERAGE_ORDER_VALUE: '#f59e0b',
  TOTAL_REVENUE: '#14b8a6',
  ITEMS_SOLD: '#06b6d4',
  TIPS: '#ec4899',
  AVERAGE_TIP_RATE: '#eab308',
} as const;

export const DEFAULT_DATE_RANGE_DAYS = 30;

export const CATEGORY_TABLE_COLUMNS = [
  { title: 'Category', dataIndex: 'name', key: 'name' },
  { title: 'Revenue', dataIndex: 'revenue', key: 'revenue', align: 'right' as const },
  { title: 'Orders', dataIndex: 'orders', key: 'orders', align: 'right' as const },
  { title: 'Avg Order', dataIndex: 'averageOrderValue', key: 'averageOrderValue', align: 'right' as const },
];

export const ITEM_TABLE_COLUMNS = [
  { title: 'Item', dataIndex: 'name', key: 'name' },
  { title: 'Revenue', dataIndex: 'revenue', key: 'revenue', align: 'right' as const },
  { title: 'Quantity', dataIndex: 'quantity', key: 'quantity', align: 'right' as const },
  { title: 'Avg Price', dataIndex: 'averagePrice', key: 'averagePrice', align: 'right' as const },
];

export const EMPTY_STATE_MESSAGES = {
  TIME_SERIES: 'No time series data available for this period.',
  CATEGORY_SALES: 'No category sales data available for this period.',
  ITEM_SALES: 'No item sales data available for this period.',
} as const;

export const REPORT_TYPE = {
  CUSTOM_RANGE: 'custom_range',
} as const;

/**
 * Format number with commas and 2 decimal places
 * @param value - Number to format
 * @returns Formatted string
 */
export const addCommasInPrices = (value: number | string): string => {
  return (parseFloat(String(value)) || 0).toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};
